import { MeshType } from '@inter-ikea-kvadrat/kvadrat';

import getAssetsPath from 'utils/getAssetsPath';

export type RoomMaterial = {
  id: string;
  url: string;
  previewUrl: string;
  colorCode?: string;
};

export type RenderSettings = Readonly<{
  environmentMap: {
    url: string;
    intensity: number;
    rotation: number;
    localMode: {
      size: { x: number; y: number; z: number };
      position: { x: number; y: number; z: number };
    };
  };
  roomMaterials: RoomMaterial[];
}>;


export const RoomMaterialAssets = {
  WALL: getAssetsPath('./room/wall/wall_lowres.gltf'),
  SKIRTING: getAssetsPath('./room/skirting/skirting.gltf'),
  FLOOR: getAssetsPath('./room/floor/floor-embeded_lowres.glb')
};

export const defaultRenderSettings: RenderSettings = {
  environmentMap: {
    url: getAssetsPath('./210609_pax_env_lowres_2.env'),
    intensity: 1.5,
    rotation: 29.9,
    localMode: {
      size: { x: 4.5, y: 5, z: 5.5 },
      position: { x: 0, y: 1.5, z: 2 }
    }
  },
  roomMaterials: [
    {
      id: MeshType.WALL,
      url: RoomMaterialAssets.WALL,
      previewUrl: ''
    },
    {
      id: MeshType.SKIRTING,
      url: RoomMaterialAssets.SKIRTING,
      previewUrl: ''
    },
    {
      id: MeshType.FLOOR,
      url: RoomMaterialAssets.FLOOR,
      previewUrl: ''
    },
    {
      id: MeshType.THICKNESS,
      url: '',
      previewUrl: '',
      colorCode: '#FFFFFF'
    },
    {
      id: MeshType.CEILING,
      url: '',
      previewUrl: '',
      colorCode: '#FFFFFF'
    }
  ]
};
